export default __webpack_public_path__ + "c5a63f7caf68f7d2a152cc5d7b1dbf6d.png";